import React, { useEffect, useState } from "react"
import { reduxForm, Field } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Col, Nav, NavLink, Row, TabContent, TabPane } from "reactstrap"
import validate from "./formValidation"
import ContentTab from "./contentTab"
import SettingsTab from "./settingsTab"
import DesignTab from "./designTab"
import BottomNavigation from "components/BottomNavigation"

const PopupForm = props => {
  const { handleSubmit, loading, initialValues, setBreadcrumbItems } = props
  const TABS = {
    CONTENT: 1,
    SETTINGS: 2,
    DESIGN: 3,
  }

  const [activeTab, setActiveTab] = useState(TABS.CONTENT)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    setBreadcrumbItems([
      { title: "Dashboard" },
      {
        title: "Pop Up",
        type: "tab",
        clickHandler: () => {
          setActiveTab(TABS.CONTENT)
        },
      },
      {
        title:
          activeTab === 1 ? "Content" : activeTab === 2 ? "Settings" : "Design",
      },
    ])
  }, [activeTab])

  return (
    <form onSubmit={handleSubmit}>
      <Nav pills tabs>
        <NavLink
          className={markIfIsActive(TABS.CONTENT)}
          onClick={() => setActiveTab(TABS.CONTENT)}
        >
          {<span style={{ fontSize: "16px" }}>Content</span>}
        </NavLink>
        <NavLink
          className={markIfIsActive(TABS.SETTINGS)}
          onClick={() => setActiveTab(TABS.SETTINGS)}
        >
          {<span style={{ fontSize: "16px" }}>Settings</span>}
        </NavLink>
        <NavLink
          className={markIfIsActive(TABS.DESIGN)}
          onClick={() => setActiveTab(TABS.DESIGN)}
        >
          {<span style={{ fontSize: "16px" }}>Design</span>}
        </NavLink>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane style={{ animation: "none" }} tabId={TABS.CONTENT}>
          <ContentTab
            tabIsActive={activeTab === TABS.CONTENT}
            handleSave={handleSubmit}
          />
          <BottomNavigation
            handleNext={() => setActiveTab(TABS.SETTINGS)}
            handleSave={handleSubmit}
            loading={loading}
          />
        </TabPane>
        <TabPane style={{ animation: "none" }} tabId={TABS.SETTINGS}>
          <SettingsTab
            tabIsActive={activeTab === TABS.SETTINGS}
            handleSave={handleSubmit}
          />
          <BottomNavigation
            handleNext={() => setActiveTab(TABS.DESIGN)}
            handleBack={() => setActiveTab(TABS.CONTENT)}
            handleSave={handleSubmit}
            loading={loading}
          />
        </TabPane>
        <TabPane style={{ animation: "none" }} tabId={TABS.DESIGN}>
          <DesignTab
            tabIsActive={activeTab === TABS.DESIGN}
            handleSave={handleSubmit}
          />
          <BottomNavigation
            handleBack={() => setActiveTab(TABS.SETTINGS)}
            handleSave={handleSubmit}
            loading={loading}
          />
        </TabPane>
      </TabContent>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAMES.POPUP, // must be unique
  validate,
})(PopupForm)
